module.exports = __webpack_public_path__ + "static/media/banner.cfcdb8d4.jpg";